import React from 'react';
import { Divider } from "@heroui/react";
import { VesselCharacteristicsDynamicAccordion } from '../components/filter-detail/Vessel-Characteristics-Dynamic-Accordion';
import { SectorFilter } from '../types/classes/SectorFilter';
import { useAppSelector } from '../../../core/rootHooks';
import { selectIsFiltersLoading, selectSectorDynamicUIFields } from '../filterSelectors';

interface IFilterVesselCharacteristicsSelectionProps {
    initialCheckedState?: boolean[][];
    sectorFilter: SectorFilter;
}

const FilterVesselCharacteristicsSelection: React.FC<IFilterVesselCharacteristicsSelectionProps> = ({ ...props }) => {



    const sectorDynamicUIFields = useAppSelector(selectSectorDynamicUIFields);
    const isFiltersLoading = useAppSelector(selectIsFiltersLoading);




    return (
        <div className="flex flex-col" style={{ width: '400px' }}>
            <div className="flex-initialp x-3 py-1 text-center" >
                <label className="text-lg font-semibold text-msi-midblue-color-500">Vessel Characteristics</label>
            </div>
            <Divider className='w-auto ml-2 mt-1' />

            {/* Dynamic rendering of Accordion Menu by subscribed vessels */}

            <VesselCharacteristicsDynamicAccordion isFiltersLoading={isFiltersLoading} sectorFilter={props.sectorFilter} sectorDynamicUIFields={sectorDynamicUIFields} />

        </div>
    );
};

export default FilterVesselCharacteristicsSelection;


